import { MaterialService } from './../../../../../../../shared/src/lib/service/material.service';
import { ProfilePhotosService } from './../../../../../../../shared/src/lib/service/profilePhotos.service';
import { Teacher } from './../../../../../../../shared/src/lib/model/teacher.model';
import { Occurrence } from './../../../../../../../shared/src/lib/model/occurrence.model';
import { RatingStudent } from './../../../../../../../shared/src/lib/model/rating-student.model';
import { ExerciceSheetService } from './../../../../../../../shared/src/lib/service/exerciceSheet.service';
import { Formation } from './../../../../../../../shared/src/lib/model/formation.model';
/**
 * Composant editer et valider la creation d'un rapport.
 */

import { Component, OnInit, Input, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ExerciceAssignedComponent } from '../../../../../../../shared/src/lib/feature/exercice-assigned/exercice-assigned.component';
import { AssignExerciceComponent } from '../../../../upcoming-classes/assign-exercice/assign-exercice.component';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators, FormArray } from '@angular/forms';
import { SessionService } from '../../../../../../../shared/src/lib/service/session.service';
import { RateStudentService } from '../../../../../../../shared/src/lib/service/rate-student.service';
import { OccurrenceService } from '../../../../../../../shared/src/lib/service/occurrence.service';
import { HttpParams } from '@angular/common/http';
import { AuthenticationService } from '../../../../../../../shared/src/lib/service/authentification.service';
import { param } from 'jquery';
import { Exercice } from '../../../../../../../shared/src/lib/model/exercice.model';
import { TaskService } from '../../../../../../../shared/src/lib/service/task.service';
import { Task } from '../../../../../../../shared/src/lib/model/task.model';
import { ProgressGaugeComponent } from '../../../../../../../shared/src/lib/feature/progress-gauge/progress-gauge.component';
import { FormationService } from '../../../../../../../shared/src/lib/service/formation.service';

@Component({
  selector: 'app-valid-session',
  templateUrl: './valid-session.component.html',
  styleUrls: ['./valid-session.component.scss']
})
export class ValidSessionComponent implements OnInit {
  @ViewChild(ProgressGaugeComponent) gaugeComponent!: ProgressGaugeComponent;

  @Input() pending: Occurrence;
  @Input() formation: Formation;
  @Input() lessonTakePlace;
  myUser: Teacher;
  nextOccurrence: Occurrence;
  sheetPermission = false;
  isSheetLanguageAvailable = false;
  loadedSession = false;
  loadedNextSession = false;
  loadedRating = false;
  saveLoading = false;
  cecrl_LEVEL = []
  percentList = [0, 25, 50, 75, 100]
  lastReport: RatingStudent = null;
  feedbackCtrl = new FormControl('', [Validators.required, Validators.minLength(100)]);
  nextTimeMessageCtrl = new FormControl();
  grammarLevelCtrl = new FormControl('', [Validators.required]);
  grammarPercentCtrl = new FormControl('', [Validators.required]);
  expressionLevelCtrl = new FormControl('', [Validators.required]);
  expressionPercentCtrl = new FormControl('', [Validators.required]);
  comprehensionLevelCtrl = new FormControl('', [Validators.required]);
  comprehensionPercentCtrl = new FormControl('', [Validators.required]);
  vocabularyLevelCtrl = new FormControl('', [Validators.required]);
  vocabularyPercentCtrl = new FormControl('', [Validators.required]);
  accentLevelCtrl = new FormControl('', [Validators.required]);
  accentPercentCtrl = new FormControl('', [Validators.required]);
  oralLevelCtrl = new FormControl('', [Validators.required]);
  writtenLevelCtrl = new FormControl('', [Validators.required]);
  reportForm: FormGroup;

  borneMin: number;
  borneMax: number;
  expectedIncident: boolean = false;
  description = new FormControl('', [Validators.required, Validators.minLength(100)]);

  hasAssignedTasks = false;
  pendingExerciceOffsite: Task[] = null;
  taskForm: FormGroup;
  assigned_exercises_duration: number = 0;
  should_be_assigned: number = 0;
  minutes_exercices_per_visio: number = 0;
  extraShouldBeAssigned: number = 0; // ajout dynamique basé sur la durée de la session

  translatePath = 'teacher.reports';

  // Gestion modal assign-exercice
  componentToLoad: any;
  componentName: string;
  modalParams: any;
  showAssignModal = false; // simple flag pour *ngIf sur <app-modal>

  // Références directes aux composants enfant pour déclencher reload()
  @ViewChild('onsiteAssigned') onsiteAssigned: ExerciceAssignedComponent;
  @ViewChild('offsiteAssigned') offsiteAssigned: ExerciceAssignedComponent;
  /** Incrémenté à la fermeture de la modal pour recharger les listes assignées */
  assignedReloadToken = 0;

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private sessionService: SessionService,
    private ratingStudentService: RateStudentService,
    private occurrenceService: OccurrenceService,
    private exerciceSheetService: ExerciceSheetService,
    private builder: FormBuilder,
    private profilePhotosService: ProfilePhotosService,
    private materialService: MaterialService,
    private taskService: TaskService,
    private fb: FormBuilder,
    private formationService: FormationService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    this.taskForm = this.fb.group({
      tasks: this.fb.array([]),
    });
  }

  ngOnInit() {
    this.reportForm = this.builder.group({
      feedback: this.feedbackCtrl,
      nextTime: this.nextTimeMessageCtrl,
      grammarLevel: this.grammarLevelCtrl,
      grammarPercent: this.grammarPercentCtrl,
      expressionLevel: this.expressionLevelCtrl,
      expressionPercent: this.expressionPercentCtrl,
      comprehensionLevel: this.comprehensionLevelCtrl,
      comprehensionPercent: this.comprehensionPercentCtrl,
      vocabularyLevel: this.vocabularyLevelCtrl,
      vocabularyPercent: this.vocabularyPercentCtrl,
      accentLevel: this.accentLevelCtrl,
      accentPercent: this.accentPercentCtrl,
      oralLevel: this.oralLevelCtrl,
      writtenLevel: this.writtenLevelCtrl,
    });

    this.cecrl_LEVEL = this.exerciceSheetService.getcecrlLevel()
    this.authenticationService.currentUserSubject.subscribe(
      user => {
        if (user && user.hasOwnProperty('user')) {
          this.checkSheetsPermission();
          this.myUser = user;
          this.checkAvailableLanguageSheets();
          this.getOrCreateSession();
          this.getNextOccurrence()
          this.getLastReport();
          // this.getExpectedRating();
          this.getAssignedExerciceList();
          this.getAssignedExercisesDuration();
          this.reloadExerciceDuration();
        }
      }
    )
  }

  getAssignedExerciceList() {
    const params = new HttpParams()
      .set('salt', Math.random().toString())
      .set('recipient_model', 'student')
      .set('recipient_entity_id', this.pending.student.id.toString())
      .set('what_model', 'exercice')
      .set('for_model', 'formation')
      .set('for_entity_id', this.formation.id.toString())
      .set('is_validate_by_student', this.pending.student.id.toString())
      .set('is_todo_by_student', this.pending.student.id.toString())
      .set('tasks_exercice__type_exercice', 'offsite')
      .set('exclude_session', this.pending.session.id.toString())
      .set('status', 'open');

    this.taskService.getTasks(params).subscribe(data => {
      if (data.results) {
        this.pendingExerciceOffsite = data.results;
        this.populateForm();
      }
    })
  }

  populateForm() {
    const tasksArray = this.taskForm.get('tasks') as FormArray;
    this.pendingExerciceOffsite.forEach((task) => {
      tasksArray.push(
        this.fb.group({
          id: [task.id],
          value: [true],
          recreate: [false],
          task: [task]
        })
      );
    });
  }

  submitTasks() {
    const formValues = this.taskForm.value.tasks;
    formValues.forEach((task: { id: number; value: boolean, recreate: boolean, task }) => {
      if (task.value === true) {
        this.taskService.patchTask(task.id, { status: 'completed' }).subscribe(data => {
        });
      }
      if (task.value === false) {
        if (task.recreate === true) {
          this.recreateTask(task.task);
        }
      }
    });
  }

  recreateTask(task) {
    const _params = {
      title: 'Exercice offsite à faire',
      task_sender: 'teacher',
      sender_entity_id: task.sender_entity_id,
      task_recipient: 'student',
      recipient_entity_id: task.recipient_entity_id,
      what_entity: 'exercice',
      what_entity_id: task.what_entity_id,
      for_entity: 'formation',
      for_entity_id: this.formation.id,
      session: this.pending.session.url
    };
    this.taskService.postTask(_params).subscribe(() => { })
  }

  updateAssignedTasks(value: boolean) {
    this.hasAssignedTasks = value;
  }

  getExpectedRating() {
    this.occurrenceService.getObservableExpectedRating(this.pending.id)
      .subscribe(rating => {
        this.borneMax = rating.max
        this.borneMin = rating.min
      })
  }

  getOrCreateSession() {
    if (this.pending.session) {
      this.feedbackCtrl.setValue(this.pending.session.message);
      this.loadedSession = true;
    } else {
      const body = {
        formation: this.formation.url,
        teacher: this.myUser.url,
        occurrence: this.pending.url
      }
      // on crée la session manquante
      this.sessionService.postNewSession(this.formation.url, body)
        .subscribe(session => {
          this.pending.session = session;
          this.loadedSession = true;
        })
    }
  }

  getNextOccurrence() {
    let params = new HttpParams();
    params = params.append('formation', this.formation.id.toString());
    params = params.append('teacher', this.myUser.id.toString());
    params = params.append('upcoming', 'true');
    // On recherche les prochaines occurences pour cette formation et ce professuer
    this.occurrenceService.getObservableOccurences(params)
      .subscribe(_occurrence => {
        if (_occurrence['count'] > 0) {
          if (_occurrence['results'][0]) {
            this.nextOccurrence = _occurrence['results'][0]
            this.nextTimeMessageCtrl = new FormControl('', [Validators.required, Validators.minLength(100)]);
            this.checkSessionForNextOccurrence()
          }
        } else {
          this.loadedNextSession = true;
        }
      })
  }


  checkSessionForNextOccurrence() {
    // on check si une session existe pour la prochaine occurrence
    if (!this.nextOccurrence.session) {
      const body = {
        formation: this.formation.url,
        teacher: this.myUser.url,
        occurrence: this.nextOccurrence.url
      }
      // on crée la session manquante
      this.sessionService.postNewSession(this.formation.url, body)
        .subscribe(session => {
          this.nextOccurrence.session = session;
          this.loadedNextSession = true;
        })
    } else {
      this.nextTimeMessageCtrl.setValue(this.nextOccurrence.session.message);
      this.loadedNextSession = true
    }
  }



  normalizePercentValue(value) {
    const _percentList = this.percentList.map(x => x); // clone percent list
    _percentList.sort(function (a, b) {
      return b - a;
    });
    let percentVal = value;
    _percentList.forEach(percent => {
      if (value <= percent) {
        percentVal = percent;
      }
    });
    return percentVal;
  }

  loadReportData() {
    if (this.lastReport) {
      this.grammarLevelCtrl.setValue(this.lastReport.level_grammar);
      this.grammarPercentCtrl.setValue(this.normalizePercentValue(this.lastReport.grammar));
      this.expressionLevelCtrl.setValue(this.lastReport.level_expression);
      this.expressionPercentCtrl.setValue(this.normalizePercentValue(this.lastReport.expression));
      this.comprehensionLevelCtrl.setValue(this.lastReport.level_comprehension);
      this.comprehensionPercentCtrl.setValue(this.normalizePercentValue(this.lastReport.comprehension));
      this.vocabularyLevelCtrl.setValue(this.lastReport.level_vocabulary);
      this.vocabularyPercentCtrl.setValue(this.normalizePercentValue(this.lastReport.vocabulary));
      this.accentLevelCtrl.setValue(this.lastReport.level_accent);
      this.accentPercentCtrl.setValue(this.normalizePercentValue(this.lastReport.accent));
      this.oralLevelCtrl.setValue(this.lastReport.level_oral);
      this.writtenLevelCtrl.setValue(this.lastReport.level_written);
    }
    this.loadedRating = true;
  }

  getLastReport() {
    if (this.formation) {
      let params = new HttpParams();
      params = params.append('status', 'completed');
      params = params.append('session__formation__student', this.formation.student.id.toString());
      params = params.append('session__formation__language', this.formation.language_detail.id.toString());
      params = params.append('ordering', '-session__occurrence__start');
      params = params.append('page_size', '1');
      this.ratingStudentService.getRatingStudents(params).subscribe(rates => {
        if (rates['results'].length > 0) {
          this.lastReport = rates['results'][0];
          this.loadReportData();
        } else {
          this.loadedRating = true;
          this.lastReport = this.ratingStudentService.selfReportedLevelToRatingStudent(this.formation.niveau);
          this.loadReportData();
        }
      });
    }
  }

  save() {
    this.saveLoading = true;
    if (this.formation.student.user.photo_profile_validation_requested) {
      this.materialService.openSnackBar('Please verify identity', 'red');
      this.saveLoading = false;
    } else {
      this.occurrenceService.patchObservableOccurrence(this.pending.url, { status: 'done' }).subscribe(occurrence => {
        this.postRating();
        this.submitTasks();
      });
      // sauvegarde du message de feedback de cours
      this.sessionService.patchSession(this.pending.session.url, { message: this.feedbackCtrl.value })
      /** save next session message */
      if (this.nextOccurrence) {
        this.sessionService.patchSession(this.nextOccurrence.session.url, { message: this.nextTimeMessageCtrl.value })
      }
    }
  }

  postRating() {
    let _param: {
      message: any;
      session: string;
      level_grammar: any;
      grammar: any;
      level_expression: any;
      expression: any;
      level_comprehension: any;
      comprehension: any;
      level_vocabulary: any;
      vocabulary: any;
      level_accent: any;
      accent: any;
      level_oral: any;
      level_written: any;
      status: string;
      description?: any;
      borne_max?: any;
      borne_min?: any;
    } = {
      message: this.feedbackCtrl.value,
      session: this.pending.session['url'],
      level_grammar: this.grammarLevelCtrl.value,
      grammar: this.grammarPercentCtrl.value,
      level_expression: this.expressionLevelCtrl.value,
      expression: this.expressionPercentCtrl.value,
      level_comprehension: this.comprehensionLevelCtrl.value,
      comprehension: this.comprehensionPercentCtrl.value,
      level_vocabulary: this.vocabularyLevelCtrl.value,
      vocabulary: this.vocabularyPercentCtrl.value,
      level_accent: this.accentLevelCtrl.value,
      accent: this.accentPercentCtrl.value,
      level_oral: this.oralLevelCtrl.value,
      level_written: this.writtenLevelCtrl.value,
      status: 'completed',
    };
    if (this.expectedIncident) {
      _param.description = this.description.value;
      _param.borne_max = this.borneMax;
      _param.borne_min = this.borneMin;
    }
    if (!this.pending.session.rate_teacher) {
      this.ratingStudentService.postRatingStudent(_param)
        .subscribe(_ratingStudent => {
          this.materialService.openSnackBar('Report completed !', 'green');
          this.saveLoading = true;
          this.goToReportList();
        })
    } else {
      this.ratingStudentService.patchRatingStudent(this.pending.session.rate_teacher.url, _param)
        .then(_ratingStudent => {
          this.materialService.openSnackBar('Report completed !', 'green');
          this.saveLoading = true;
          this.goToReportList();
        })
    }
  }

  goToReportList() {
    this.router.navigate(['reports']);

  }

  checkAvailableLanguageSheets() {
    this.isSheetLanguageAvailable = this.authenticationService.checkAvailableLanguageSheets(this.formation.language_detail.id);
  }

  checkSheetsPermission() {
    this.sheetPermission = this.authenticationService.checkFeaturePermission('sheets');
  }

  checkExerciceRate() {
    if (this.formation.percent_exercice_rate === 0) {
      return true;
    }
    if (this.formation.percent_exercice_rate > 0 && this.assigned_exercises_duration >= (this.should_be_assigned + this.extraShouldBeAssigned)) {
      return true;
    }
    return false;
  }

  getAssignedExercisesDuration() {
    if (!this.formation || this.formation.percent_exercice_rate === 0) {
      // Pas d'objectif d'exercices -> on évite l'appel inutile
      this.assigned_exercises_duration = 0;
      this.should_be_assigned = 0;
      this.minutes_exercices_per_visio = 0;
      this.extraShouldBeAssigned = 0;
      return;
    }
    this.formationService.getFormationExercicesInfo(this.formation.id).subscribe({
      next: (exerciceInfos) => {
        this.assigned_exercises_duration = exerciceInfos.total_assigned.duration;
        this.should_be_assigned = exerciceInfos.should_be_assigned ? Math.ceil(exerciceInfos.should_be_assigned) : 0;
        this.minutes_exercices_per_visio = exerciceInfos.minutes_exercices_per_visio || 0;
        this.computeExtraShouldBeAssigned();
      },
    });
  }

  private computeExtraShouldBeAssigned() {
    // Utilise les dates de l'occurrence (pending.start/end) car session ne porte pas ces champs
    if (!this.pending?.start || !this.pending?.end) {
      this.extraShouldBeAssigned = 0;
      return;
    }
    const start = new Date(this.pending.start).getTime();
    const end = new Date(this.pending.end).getTime();
    if (isNaN(start) || isNaN(end) || end <= start) {
      this.extraShouldBeAssigned = 0;
      return;
    }
    const durationMinutes = Math.round((end - start) / 60000);
    this.extraShouldBeAssigned = durationMinutes * this.minutes_exercices_per_visio;
  }

  reloadExerciceDuration() {
    if (this.gaugeComponent) {
      this.getAssignedExercisesDuration();
      this.gaugeComponent.getAssignedExercisesDuration();
    }
  }

  // Ouvre la modal d'assignation au lieu de router
  openAssign(type: 'onsite' | 'offsite', category?: string) {
    // Routing classique reste possible ailleurs; ici on ouvre modal.
    console.log('Open assign modal', type, category);
    this.componentToLoad = AssignExerciceComponent;
    this.componentName = 'AssignExerciceComponent';
    this.modalParams = {
      formationId: this.formation?.id,
      typeExercice: type,
      typeCategory: category,
      occurrenceId: this.pending?.id,
      sessionUrl: this.pending?.session?.url,
      openInModal: true
    };
    this.showAssignModal = true;
    this.changeDetectorRef.detectChanges();
  }

  closeAssignModal() {
    this.showAssignModal = false;
    // Rafraîchir les durées si des assignations ont changé
    this.getAssignedExercisesDuration();
    this.reloadExerciceDuration();
    // Forcer le rechargement des listes (ViewChild.reload est peu fiable avec @if)
    this.assignedReloadToken++;
    this.onsiteAssigned?.reload();
    this.offsiteAssigned?.reload();
    this.changeDetectorRef.detectChanges();
  }

  handleModalEvent(event: any) {
    console.log('Modal event received in valid-session:', event);
    if (event?.component === 'AssignExerciceComponent' && event?.action === 'closed') {
      this.closeAssignModal();
    }
  }
}
